import { type GetProspectForStaffReviewQuery } from "common/types/gqlSchemaTypes";

type ProspectContactMaps = NonNullable<
  NonNullable<GetProspectForStaffReviewQuery["subscription"]>["prospect"]
>["prospectContactMaps"];

export const getContactStrings = (
  prospectContactMaps?: ProspectContactMaps,
): [string, string] => {
  const validContacts = prospectContactMaps?.filter(
    (pcm) => pcm?.contact?.primaryEmail?.emailAddress && pcm.dataRoomKey,
  );
  const primaryContacts: string[] = [];
  const secondaryContacts: string[] = [];
  validContacts?.forEach((pcm) => {
    const contactString = `${pcm?.contact?.fullName} (${pcm?.contact?.primaryEmail?.emailAddress})`;
    if (pcm?.isMainContact) {
      primaryContacts.push(contactString);
    } else {
      secondaryContacts.push(contactString);
    }
  });
  const primaryContactsString = primaryContacts.join(", ");
  const secondaryContactsString = secondaryContacts.join(", ");
  return [primaryContactsString, secondaryContactsString];
};
